import React from 'react';
import { Bot } from 'lucide-react';
import { Avatar, AvatarFallback, AvatarImage } from './ui/avatar';

const getInitials = (name = '') => {
  const parts = name.trim().split(/\s+/).filter(Boolean).slice(0, 2);
  if (!parts.length) return 'AI';
  return parts.map((part) => part[0]?.toUpperCase()).join('');
};

const AgentAvatar = ({ name, avatarUrl, className = 'h-10 w-10', fallbackClassName = '' }) => {
  return (
    <Avatar className={className}>
      {avatarUrl ? <AvatarImage src={avatarUrl} alt={`${name || 'Agent'} avatar`} /> : null}
      <AvatarFallback className={fallbackClassName || 'bg-primary/10 text-primary font-semibold'}>
        {avatarUrl ? <Bot className="w-4 h-4" /> : getInitials(name)}
      </AvatarFallback>
    </Avatar>
  );
};

export default AgentAvatar;
